import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { currentLocale, LOCALES, setLocale } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/**
 * השלב הראשון בהרשמה: שפת הממשק. הבחירה מחליפה שפה וכיוון מיד, בלי טעינה
 * מחדש — כך מצב האשף נשמר. השפה נשלחת עם ההרשמה (locale) ונשמרת לעסק.
 */
export function LanguageStep({ onContinue }: { onContinue: () => void }) {
  // useTranslation — כדי שהמסך יתרנדר מחדש כשהשפה מתחלפת.
  const { t } = useTranslation(['onboarding', 'common']);
  const selected = currentLocale();

  return (
    <Card>
      <CardHeader>
        <CardTitle id="language-title" className="text-base">
          {t('language.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div role="radiogroup" aria-labelledby="language-title" className="grid gap-3 sm:grid-cols-2">
          {LOCALES.map((l) => {
            const on = selected === l;
            return (
              <button
                key={l}
                type="button"
                role="radio"
                aria-checked={on}
                lang={l}
                dir={l === 'he' ? 'rtl' : 'ltr'}
                onClick={() => setLocale(l, { reload: false })}
                className={cn(
                  'relative flex min-h-24 items-center justify-center rounded-(--radius-lg) border px-4 py-6 text-xl font-semibold transition-colors',
                  on
                    ? 'border-accent bg-accent-subtle text-accent'
                    : 'border-border bg-surface text-fg hover:bg-surface-hover',
                )}
              >
                {on ? <Check className="absolute top-3 start-3 size-4" aria-hidden /> : null}
                {t(`common:language.${l}`)}
              </button>
            );
          })}
        </div>
        <Button size="lg" className="w-full" onClick={onContinue}>
          {t('common:actions.continue')}
        </Button>
      </CardContent>
    </Card>
  );
}
